import type { TrackedTranslation } from '@ps/web-core-intl';
import type { Validators } from '@ps/web-shared-validators';
import React from 'react';

import useCursorPosition from '@swf/core/hooks/useCursorPosition';

import useAutoFocusInput from '../../../../../../hooks/useAutoFocusIf';
import TextInput from '../../../../../TextInput/TextInput';

const FIELD_NAME = 'docNumber';
const MIN_LENGTH = 8;
const MAX_LENGTH = 20;

const parse = (value: string) => value.replace(/[^A-Za-z0-9]/g, '');

interface Props {
  label: string | TrackedTranslation;
  validator?: Validators;
  labelContent?: React.ReactNode;
  className?: string;
  maxLength?: number;
  minLength?: number;
}

const DocumentNumberField: React.FC<Props> = ({
  label,
  validator,
  labelContent,
  className,
  minLength = MIN_LENGTH,
  maxLength = MAX_LENGTH
}) => {
  const inputEl = useAutoFocusInput(false);
  useCursorPosition(inputEl, maxLength, FIELD_NAME);

  return (
    <TextInput
      id={FIELD_NAME}
      inputRef={inputEl}
      className={className}
      labelContent={labelContent}
      minLength={minLength}
      maxLength={maxLength}
      parse={parse}
      label={label}
      validators={validator}
      checkDisabled
    />
  );
};
export default DocumentNumberField;
